import { matchPath } from 'react-router';

export const ROOT = '/:companyId';
export const CLOUD_FOLDER = '/:companyId/team-folders';
export const CLOUD_FOLDER_TAB = '/:companyId/team-folders/:tab';
export const CLOUD_FOLDER_TAB_ASSET = '/:companyId/team-folders/:tab/:asset';
export const SUBSCRIPTION = '/:companyId/subscription';
export const SUBSCRIPTION_PLUS_OVERVIEW = '/:companyId/subscription/plus-overview/:currency?';
export const SUBSCRIPTION_PERPETUAL_OVERVIEW = '/:companyId/subscription/perpetual-overview/:currency?';
export const SUBSCRIPTION_UPGRADE = '/:companyId/subscription/:planId';
export const SUBSCRIPTION_SUCCESSFUL = '/:companyId/subscription-successful';
export const XC_PLUS = '/:companyId/xcplus';
export const USERS = '/:companyId/users';
export const FONTS = '/:companyId/fonts';
export const SMART_FIELDS = '/:companyId/smart-fields';
export const NOT_FOUND = '/not-found';
export const UI = '/ui';
export const ONBOARDING = '/onboarding';
export const NO_PERMISSIONS = '/no-permissions';
export const PAGE_NOT_AVAILABLE = '/:companyId/page-not-available';
export const WRONG_ACCOUNT = '/:companyId/wrong-account';
export const ACCOUNT_DETAILS = '/:companyId/account';
export const CUSTOMIZE = '/:companyId/customize';

export const getRoute = (route, ...params) => {
	let count = 0;
	return route.replace(/:[a-zA-Z?]+/g, match => {
		return params[count++] || match;
	});
};

export const routeMatches = (route, location, options) => {
	const { pathname } = location;
	return matchPath(pathname, { path: route, exact: true, strict: false, ...options }) !== null;
};



// WEBPACK FOOTER //
// ./src/routes.js